import React, { useEffect, useState } from 'react';
import Badge from 'components/commons/badge';
import { useAntiFraudHelper } from '../../hooks';
import { AntiFraud, BorrowerPosition } from 'generated/graphql';
import useNavigation from 'hooks/navigation';
import arrowRightIcon from 'assets/svg/arrow-right.svg';

type LivenessStatusBarProps = {
    antiFraud: AntiFraud;
    borrowerPosition: BorrowerPosition;
}

const LivenessStatusBar: React.FC<LivenessStatusBarProps> = ({ antiFraud, borrowerPosition }) => {
    const [updatedAntiFraud, setUpdatedAntiFraud] = useState(antiFraud);

    const {
        goToShareAntiFraudPartner,
        goToPartnerNotIdentified
    } = useNavigation();

    const {
        borrowerIsPartner,
        hasApplicant,
        livenessIsDraft,
        hasWorthyCreditToAnswer
    } = useAntiFraudHelper(updatedAntiFraud, borrowerPosition);

    useEffect(() => {
        setUpdatedAntiFraud(antiFraud);
    }, [antiFraud]);

    const RenderStepWorthyCredit = () =>
    (
        <div>
            <div>
                <h4 className="overline">{'Passo 3'}</h4>
                <p className="body-1">Completar  perfil financeiro para aumentar suas chances de aprovação</p>
            </div>
            <div>
                {
                    hasApplicant()
                    && (
                        <Badge variant="tangerine">
                            pendente
                        </Badge>
                    )
                }
            </div>
        </div>
    )


    return (
        <div className="bizon-liveness-steps-info mb-3">
            {!borrowerIsPartner() &&
                <div>
                    <div>
                        <h4 className="overline">Passo 1</h4>
                        <p className="body-1">Validação de sócio/dono</p>
                    </div>
                    <div>
                        {!hasApplicant() && (
                            <>
                                <Badge variant="tangerine">
                                    pendente
                                </Badge>
                                <a className="ml-2"
                                    onClick={borrowerPosition === BorrowerPosition.Unknown ? goToPartnerNotIdentified : goToShareAntiFraudPartner}
                                >
                                    editar <img src={arrowRightIcon} />
                                </a>
                            </>
                        )}
                        {hasApplicant() && (
                            <Badge variant="green">
                                concluído
                            </Badge>
                        )}
                    </div>
                </div>
            }
            <div>
                <div>
                    <h4 className="overline">{borrowerIsPartner() ? 'Passo 1' : 'Passo 2'}</h4>
                    <p className="body-1">Captura do documento e foto do sócio/dono</p>
                </div>
                <div>
                    {
                        livenessIsDraft()
                        && hasApplicant()
                        && (
                            <Badge variant="tangerine">
                                pendente
                            </Badge>
                        )
                    }

                    {!livenessIsDraft() && (
                        <Badge variant="green">
                            concluído
                        </Badge>
                    )}
                </div>
            </div>
            {hasWorthyCreditToAnswer() && (<RenderStepWorthyCredit />)}
        </div>
    );
};

export default LivenessStatusBar;
